export default {
  name: 'FooterNav',
  props: {
    /* 显示项 */
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: this.activeIndex,
      home_ico: this.activeIndex == 0 ? 'wap-home' : 'wap-home-o',
      user_ico: this.activeIndex == 1 ? 'manager' : 'user-o'
    };
  },
  watch: {
    active(newValue) {
      switch (newValue) {
        case 0:
          this.$router.replace('/home');
          break;
        case 1:
          this.$router.replace('/user');
          break;
      }
      this.home_ico = newValue == 0 ? 'wap-home' : 'wap-home-o';
      this.user_ico = newValue == 1 ? 'manager' : 'user-o';
    }
  }
};